import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const OVGCenterStore = {
  namespaced: true,
  state: {
    ovgDetail: null,
  },
  getters,
  mutations,
  actions,
}

export default OVGCenterStore
